import React from 'react';

const TermsOfUse = () => {
  return (
    <div className="terms-of-use-page">
      <h1>Terms of Use</h1>
      {/* Terms of Use content will go here */}
    </div>
  );
};

export default TermsOfUse; 